import http from './http';
import LocalStorage from "../services/localStorage";

export default {
  all() {
    return http().get(`/v1/user_invites`);
  },
  create(data) {
    return http().post(`/v1/user_invites`, data);
  },
  delete(id) {
    return http().delete(`/v1/user_invites/${id}`);
  },
  acceptInvite(data) {
    return http().post('/v1/user_invites/accept', data)
      .then(response => {
        LocalStorage.setAuthUser(response.data.user);
        LocalStorage.setApiToken(response.data.api_token);
        LocalStorage.setAdminMode(response.data.is_admin);
        return {data: response.data.user}
      });
  },
  getInviteByEncryptedToken(token) {
    return http().get(`/v1/user_invites/token/${token}`);
  }
}
